import { DatePipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, Inject, OnInit, Optional, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { DynamicHelpListComponent } from 'app/EMR/Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component';
import { EMRService } from 'app/EMR/EMR.service';
import { DiseaseModel } from 'app/EMR/HistoryModels/disease.model';
import { PastHistoryModel } from 'app/EMR/HistoryModels/pasthistory.model';
import { NewDiseaseComponent } from 'app/EMR/NewDisease/NewDisease.component';
import { HelplistService } from 'app/helplist.service';
import { Observable, Subject } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-past-history',
  templateUrl: './past-history.component.html',
  styleUrls: ['./past-history.component.scss']
})
export class PastHistoryComponent implements OnInit {
  destroypast$: Subject<boolean> = new Subject<boolean>();
  private pasthistory_ds: MatTableDataSource<PastHistoryModel>
  private displayedColumns_pasthistory: string[] = ['diseasename', 'startdate', 'recoveron', 'remark', 'Action'];
  private pasthistoryList: any = [];
  private getPastHistorydata: any = [];
  private editCache: { [key: string]: any } = {};
  private filteredOptions_diseases: Observable<DiseaseModel[]>;
  private DiseaseControl = new FormControl();
  private EditId: any;
  isheader:boolean=false;
  showspinner:boolean=false;
//  @Output() functionEmitter = new EventEmitter<() => void>();
  private todaysdate = this.authService.getServerDate;
  constructor(private emrservice: EMRService,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<PastHistoryComponent>, private datePipe: DatePipe, private authService: AuthService,
    private dashboardService: DashboardService, private helplistservice: HelplistService,
    private dialog: MatDialog) {
    this.filteredOptions_diseases = this.DiseaseControl.valueChanges
      .pipe(
        startWith(null),
        map(disease => disease ? this._filterdiseases(disease) : this.helplistservice.diseaseList.slice())
      );
  }

  private _filterdiseases(value: string): DiseaseModel[] {
    const filterValue = value.toLowerCase();
    return this.helplistservice.diseaseList.filter
      (disease => disease.diseaseName.toLowerCase().indexOf(filterValue) === 0);
  }
  ngOnInit(): void {
    if(this.data){
      this.isheader = this.data.isheader;
     }else{
       this.isheader = false;
     }
    this.emrservice.enabledisablebtnpasthistory = true;
    this.pasthistory_ds = new MatTableDataSource(this.emrservice.pasthistory.slice());
  
    if(this.emrservice.pasthistory.length >0){
      this.emrservice.enabledisablebtnpasthistory =this.emrservice.pasthistory.filter(item =>item.pkTranId ==0).length >0?false:true;
    }
    this.updateEdit();
    this.filteredOptions_diseases = this.DiseaseControl.valueChanges
      .pipe(
        startWith(null),
        map(disease => disease ? this._filterdiseases(disease) : this.helplistservice.diseaseList.slice())
      );
      // const past_historyFun = () => {
      //   this.get_pasthistory();
      // };
      // this.functionEmitter.emit(past_historyFun);
      this.emrservice.share.pipe(takeUntil(this.destroypast$)).subscribe((x: any) => {
        if (x == 3) 
        {
          this.get_pasthistory(0);
        }
      });
  }
  getStartdateEdit(index): string {
    const id = index;
    return this.editCache[id].data.startDate;
  }
  
  updateEdit(): void {

    this.pasthistory_ds.data.forEach((item, index) => {
      const id = index;
      this.editCache[id] = {
        edit: false,
        data: { ...item }
      };
    });

  }

  Edit(index) {

    if (this.emrservice.pasthistoryPermission?.isModifyPermission == true) {
      const id = index;
      this.EditId = id;
      this.updateEdit();
      this.editCache[id].edit = true;
      console.log(this.editCache[id].data.diseaseName);
      if (this.editCache[id].data.startDate != "1900-01-01T00:00:00") {
        this.editCache[id].data.startDate = this.datePipe.transform(this.editCache[id].data.startDate, "yyyy-MM-dd").toString();

      } else {
        this.editCache[id].data.startDate = null;

      }
      if (this.editCache[id].data.recoveryOn != "1900-01-01T00:00:00") {

        this.editCache[id].data.recoveryOn = this.datePipe.transform(this.editCache[id].data.recoveryOn, "yyyy-MM-dd").toString();
      } else {

        this.editCache[id].data.recoveryOn = null;
      }


    } else {
      this.dashboardService.openSnackBar("Modify permission denied", "OK");
    }
  }
  saveEdit(idx,event): void {
    const id = idx;
    let payloadarray = [];
    let editpayload;
    let startdate;
    let recoverydate;
    let editlist = this.editCache[id].data;
    if (editlist.startDate != null) {
      startdate = this.datePipe.transform(editlist.startDate, "yyyy-MM-dd").toString();
    }
    if (editlist.recoveryOn != null) {
      recoverydate = this.datePipe.transform(editlist.recoveryOn, "yyyy-MM-dd").toString();
    }
    payloadarray.push({
      "diseaseName": editlist.diseaseName,
      "startDate": startdate,
      "recoveryOn": recoverydate,
      "remarks": editlist.remarks,
      "pkTranId": editlist.pkTranId,
      "fkRegId": editlist.fkRegId,
      "pkSynchId": editlist.pkSynchId,
      "fk_VisitID":this.emrservice.visitid,
      "isDelete":false,
      "isEdit": editlist.pkTranId > 0
        });
    this.editCache[id].edit = false;
    editpayload = payloadarray;
    this.emrservice.save_pasthistory_to_server(editpayload).pipe(takeUntil(this.destroypast$)).subscribe(
      data => this.success_pasthistory_saved(data,event), err => this.failed_pasthistory_saved(err,event)
    )
  }

  cancelEdit(idx): void {
    const id = idx;
    this.editCache[id].edit = false;
  }

  get_pasthistory(type:any) {
    this.emrservice.get_pasthistory(this.emrservice.visitid).pipe(takeUntil(this.destroypast$)).subscribe(
      data => this.success_pasthostory(data,type), err => this.failed_pasthistory(err)
    )
  }

  success_pasthostory(data,type) {
  
    this.pasthistoryList = [];
    this.getPastHistorydata = [];

    if (data.length > 0) {
      if(type==0){
        this.emrservice.enabledisablebtnpasthistory =data.filter(item =>item.pkTranId ==0).length >0?false:true;
      }
       
        this.pasthistory_ds.data = [];
      //   let recoverdate
      //   if(data.recoveryOn == '1900-01-01T00:00:00'){
      // recoverdate = null;
      //   }else{
      //     recoverdate = data.recoveryOn;
      //   }

      data.forEach(item => {
        this.getPastHistorydata.push({
          "diseaseName": item.diseaseName,
          "startDate": item.startDate,
          "recoveryOn": item.recoveryOn,
          "remarks": item.remarks,
          "pkTranId": item.pkTranId,
          "fkRegId": item.fkRegId,
          "pkSynchId": item.pkSynchId
        });
      });
      this.pasthistory_ds.data = this.getPastHistorydata;
      // this.pasthistoryList = this.pasthistory_ds.data;
    } else {
      this.pasthistory_ds.data = [];
    }
    this.updateEdit();
  }

  failed_pasthistory(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  adddisease() {
    if (this.emrservice.pasthistoryPermission?.isAddPermission == true) {
      this.pasthistoryList = [];
      const dialogRef = this.dialog.open(NewDiseaseComponent, {

        panelClass: 'full-width-dialog',
        maxWidth: '90vw',
        // height: '90%',
        width: '90%',
        data: {
          //  id: this.dashboardService.pid,
          //userid: this.authService.Loggeduser.userid
        }

      });

      dialogRef.afterClosed().pipe(takeUntil(this.destroypast$)).subscribe(result => {

        if (result.length > 0) {
          this.emrservice.enabledisablebtnpasthistory = false;
         
          result.forEach(item => {
            this.pasthistoryList.push({
              "diseaseName": item.diseaseName,
              "startDate": item.startDate,
              "recoveryOn": item.recoveryOn,
              "remarks": item.remarks,
              "pkTranId": item.pkTranId,
              "fkRegId": item.fkRegId,
              "pkSynchId": item.pkSynchId
            })
          })
        }

        this.pasthistoryList.forEach(item => {
          this.pasthistory_ds.data.push(item);
        });
        this.pasthistory_ds.data = this.pasthistory_ds.data.reduce((unique, o) => {
          if (!unique.some(obj => obj.diseaseName === o.diseaseName)) {
            unique.push(o);
          }
          return unique;
        }, []);
        // this.pasthistory_ds.data = [...this.pasthistory_ds.data];
        this.updateEdit();

      });
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }

  deletehistory(row) {
    if (this.emrservice.pasthistoryPermission?.isDeletePermission == true) {
      // this.emrservice.open_loader_Dialog();
      this.showspinner = true;
      if (row.pkTranId > 0) {
        this.emrservice.delete_pasthistory_on_server(row.pkTranId).pipe(takeUntil(this.destroypast$)).subscribe(
          data => this.success_delete_pasthistory(data), err => this.failed_delete_pasthistory(err)
        )
      } else {
        const index: number = this.pasthistory_ds.data.indexOf(row);
        if (index !== -1) {
          this.showspinner = false;
          this.pasthistory_ds.data.splice(index, 1);
          this.pasthistory_ds.data = [...this.pasthistory_ds.data];
        }
        // this.dialog.closeAll();
        // this.showspinner = false;
      }
    } else {
      this.dashboardService.openSnackBar("Delete permission denied", "OK");
    }
  }
  
  success_delete_pasthistory(data) {
    this.emrservice.enabledisablebtnpasthistory = true;
    this.showspinner = false;
    // this.dialog.closeAll();
    this.get_pasthistory(1);
    this.emrservice.getHistoryStatus(this.emrservice.visitid);
    this.dashboardService.openSnackBar("Systemic history successfully deleted", "OK");
  }
  failed_delete_pasthistory(err) {
    this.showspinner = false;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
    this.dialog.closeAll();
  }

  save_pasthistory(event) {
    const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
    this.pasthistory_ds.data.map(item => {
      item.fk_VisitID = this.emrservice.visitid;
      item.remarks = item.remarks ? item.remarks : "";
      item.isEdit = item.pkTranId > 0 ?true :false;     
      item.isDelete = false; 
    });
    let payload = this.pasthistory_ds.data;
    if (this.pasthistory_ds.data.length > 0) {
      // this.emrservice.open_loader_Dialog();
     this.showspinner = true ;
      this.emrservice.save_pasthistory_to_server(payload).pipe(takeUntil(this.destroypast$)).subscribe(
        data => this.success_pasthistory_saved(data,event), err => this.failed_pasthistory_saved(err,event)
      )
    } else {
        const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
                  button.removeAttribute('disabled');
      this.dashboardService.openSnackBar("Please Select The Disease", "OK");
    }
  }
  success_pasthistory_saved(data,event) {
    this.showspinner = false;
    this.emrservice.enabledisablebtnpasthistory = true;
    this.emrservice.getHistoryStatus(this.emrservice.visitid);
    this.get_pasthistory(1);
    this.emrservice.pasthistory = [];
  if (data.statusCode == 10) {
      const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
                  button.removeAttribute('disabled');
      this.dashboardService.openSnackBar("Alreday exists in the list", "OK");
    }else{
      this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
    } 

  }
  failed_pasthistory_saved(err,event) {
       const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
          button.removeAttribute('disabled');
    this.showspinner = false;
    
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
    this.dialog.closeAll();
    // console.log("insert SystemicHistory api failed");
  }
  refReasonPOpup(parameter, type) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',

      data: {
        parametertype: parameter
      }

    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroypast$)).subscribe(result => {
      if (result != 0) {
        if (type == 1) {
          this.editCache[this.EditId].data.remarks = result;
        }

      }
    });
  }
  ngOnDestroy() {
    this.destroypast$.next(true);
    this.destroypast$.unsubscribe();
    this.pasthistory_ds = null;
    this.displayedColumns_pasthistory = null
    this.pasthistoryList = null;
    this.getPastHistorydata = null;
    this.editCache = null;
    this.filteredOptions_diseases = null;
    this.DiseaseControl = null;
  }
  closedialog(){
    this.dialogRef.close();
  }
}
